import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import axios from "axios";
import constants from "../../utils/constants";
import { QueryArguments } from "../../types-business/QueryArguments";
import { CuentaContable } from "../../types/CuentaContable";

const CUENTAS_CONTABLES_BASE_URL = "/api/cuentas-contables";

export const getCuentasContables = (params?: QueryArguments): IAction => {
  return {
    type: actionTypes.GET_CUENTAS_CONTABLES,
    payload: {
      promise: axios.get(`${constants.BASE_URL}${CUENTAS_CONTABLES_BASE_URL}`, {
        withCredentials: true,
        params: { ...params, ...constants.DEFAULT_SORTING_NAMEPARAMS }
      })
    }
  };
};

export const getCatalogoCuentasContables = (): IAction => {
  return {
    type: actionTypes.GET_CATALOGO_CUENTAS_CONTABLES,
    payload: axios.get(
      `${constants.BASE_URL}${CUENTAS_CONTABLES_BASE_URL}/catalogo`,
      {
        withCredentials: true
      }
    )
  };
};

export const createCuentaContable = (fields: object): IAction => {
  return {
    type: actionTypes.CREATE_CUENTA_CONTABLE,
    payload: {
      promise: axios.post(
        `${constants.BASE_URL}${CUENTAS_CONTABLES_BASE_URL}`,
        fields,
        {
          withCredentials: true
        }
      )
    }
  };
};

export const editCuentaContable = (
  cuentaContableId: string,
  cuentaContable: CuentaContable
): IAction => {
  return {
    type: actionTypes.UPDATE_CUENTA_CONTABLE,
    payload: {
      promise: axios.put(
        `${constants.BASE_URL}${CUENTAS_CONTABLES_BASE_URL}/${cuentaContableId}`,
        cuentaContable,
        {
          withCredentials: true
        }
      )
    }
  };
};

export const deleteCuentaContableRequest = (cuentaContableId: string) => {
  return axios.delete(
    `${constants.BASE_URL}${CUENTAS_CONTABLES_BASE_URL}/${cuentaContableId}`,
    {
      withCredentials: true
    }
  );
};

export const disableCuentaContableCreated = (): IAction => {
  return {
    type: actionTypes.DISABLE_CUENTA_CONTABLE_CREATED
  };
};
